import type { RouteRecordRaw } from 'vue-router'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { insertIf } from '@backmarket/utils/collection/insertIf'

import bouyguesInStoreRoutes from './flows/bouygues-in-store/routes'
import eCommerceRoutes from './flows/e-commerce/routes'
import giftCardRoutes from './flows/gift-card/routes'

export default (): RouteRecordRaw[] => {
  const experiments = useExperiments()
  const { features } = useMarketplace()
  const isGiftCardsEnabled =
    experiments['experiment.giftCards'] === 'withGiftCards' &&
    features.giftCards.enabled

  return [
    ...eCommerceRoutes,
    ...bouyguesInStoreRoutes,
    ...insertIf(isGiftCardsEnabled, giftCardRoutes),
  ]
}
